import LoadingOverlay from '@/components/main/LoadingOverlay'
import { LoadingProvider } from '@/context/loading-context'
import { storeAffiliateData } from '@/utils/affiliate'
import { useEffect } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Toaster } from 'react-hot-toast'
import { Toaster as SonnerToaster } from 'sonner'
import { useLocation } from 'react-router-dom'
import { ErrorBoundary } from './components/error-boundary'
import AuthContextProvider from './context/auth'
import { BrandVoiceProvider } from './context/brandVoice'
import { CartProvider } from './context/cart'
import FinderContextProvider from './context/finder-context'
import FormContextProvider from './context/form'
import { LayoutPreferenceProvider } from './context/layoutPreference'
import { MiniCartProvider } from './context/mini-cart'
import SocketContextProvider from './context/socket'
import SubscriptionContextProvider from './context/subscription'
import AblyProviderWrapper from './hoc/Ably'
import MiniCart from './modules/flows/flows-store/components/MiniCart'
import AppRoutes from './routes'

function App() {
    const location = useLocation()

    // Scroll to top on every route change
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' })
    }, [location.pathname])

    // Store affiliate data on initial load and route changes
    useEffect(() => {
        storeAffiliateData().catch(error => {
            console.error('Error storing affiliate data:', error)
        })
    }, [location.search])

    return (
        <ErrorBoundary>
            <LoadingProvider>
                <AuthContextProvider>
                    <CartProvider>
                        <MiniCartProvider>
                            <AblyProviderWrapper>
                                <SocketContextProvider>
                                    <FinderContextProvider>
                                        <BrandVoiceProvider>
                                            <LayoutPreferenceProvider>
                                                <SubscriptionContextProvider>
                                                    <FormContextProvider>
                                                        <DndProvider backend={HTML5Backend} context={window}>
                                                            <AppRoutes />
                                                        </DndProvider>

                                                        <Toaster
                                                            toastOptions={{
                                                                success: {
                                                                    style: {
                                                                        background: 'green',
                                                                        color: 'white',
                                                                    },
                                                                },
                                                                error: {
                                                                    style: {
                                                                        background: 'red',
                                                                        color: 'white',
                                                                    },
                                                                },
                                                                position: 'top-right',
                                                                style: {
                                                                    minWidth: '300px',
                                                                    maxWidth: '480px',
                                                                },
                                                            }}
                                                        />
                                                        <SonnerToaster position="top-right" />
                                                        <MiniCart />
                                                    </FormContextProvider>
                                                </SubscriptionContextProvider>
                                            </LayoutPreferenceProvider>
                                        </BrandVoiceProvider>
                                    </FinderContextProvider>
                                </SocketContextProvider>
                            </AblyProviderWrapper>
                        </MiniCartProvider>
                    </CartProvider>
                </AuthContextProvider>
                <LoadingOverlay />
            </LoadingProvider>
        </ErrorBoundary>
    )
}

export default App
